import React from 'react';
import { GoogleLogin } from 'react-google-login';

import urls from 'base/urls';
import API from 'base/api';
import auth, { CLIENT_ID } from 'base/auth';

class LoginPage extends React.Component{
  responseGoogle (response) {
    console.log(response);
    auth.clearAppStorage();
    // auth.setToken(response.accessToken);
    // console.log(auth.getToken());
    // document.location.href = '/admin';

    if (response.accessToken){
      fetch(API.AUTH, {
        method: 'POST',
        body: JSON.stringify({"access_token": response.accessToken}),
        headers: new Headers({
          'Content-Type': 'application/json'
        })
      })
      .then( res => {
        if (res.ok) {
          return res.json();
        } else {
          throw new Error('Something went wrong ...');
        }
      })
      .then( res => {
        console.log("Success: ", res)
        auth.setToken(res.token);
        document.location.replace("/admin");
      })
      .catch(error => alert("Error: ", error));
    } else {
      alert(response.error);
    }

  }

  render () {
    // const { from } = this.props.location.state;
    // console.log(from)
    return (
      <div style={{
        "position": "fixed",
        "top": "50%",
        "left": "50%",
        "transform": "translate(-50%, -50%)"
      }}>
        {console.log(this.props.location)}
        <GoogleLogin
          clientId={CLIENT_ID}
          onSuccess={this.responseGoogle}
          onFailure={this.responseGoogle}
          redirectUri={urls.ADMIN_PANEL}
        >
          Login with Google
        </GoogleLogin>
      </div>
    );
  }

}

export default LoginPage;


// WEBPACK FOOTER //
// ./src/base/views/LoginPage.js